import { useAccessibility } from "../../../context/AccessibilityContext/AccessibilityContext";
import Block from "../../../components/Block/Block";
import FadeIn from "../../../components/FadeIn/FadeIn";
import Link from "../../../components/Link/Link";
import style from './documentsblock.module.scss';
import { useEffect, useState } from 'react';
import { fetchDocumentsInfo } from '../../../services/api'; // Новая функция

const DocumentsBlock = () => {
    const { settings } = useAccessibility();
    const [documentsData, setDocumentsData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    // Accessibility-aware colors
    const backgroundColor = settings.contrast === 'default' ? 'rgba(255, 255, 255, 0.85)' : 'var(--bg-primary)';
    const textColor = settings.contrast === 'default' ? '#231f20' : 'var(--text-primary)';
    const linkColor = settings.contrast === 'default' ? '#1d3e8c' : 'var(--accent-color)';

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await fetchDocumentsInfo();
                // Данные теперь в response.data[0].attributes
                setDocumentsData(response.data[0].attributes);
                console.log('Documents data:', response.data[0].attributes);
            } catch (err) {
                console.error('Error fetching documents:', err);
                setError('Не удалось загрузить документы. Пожалуйста, попробуйте позже.');
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, []);

    if (loading) return (
        <Block
            flexDirection='column'
            justifyContent='start'
            alignItems='start'
            width="75%"
            height='200px'
            background={backgroundColor}
            header='ДОКУМЕНТЫ'
            headerColor={textColor}
        >
            <div>Загрузка документов...</div>
        </Block>
    );

    if (error) return (
        <Block
            flexDirection='column'
            justifyContent='start'
            alignItems='start'
            width="75%"
            height='200px'
            background={backgroundColor}
            header='ДОКУМЕНТЫ'
            headerColor={textColor}
        >
            <div>{error}</div>
        </Block>
    );

    if (!documentsData) {
        return (
            <Block
                flexDirection='column'
                justifyContent='start'
                alignItems='start'
                width="75%"
                height='200px'
                background={backgroundColor}
                header='ДОКУМЕНТЫ'
                headerColor={textColor}
            >
                <div>Документы не найдены</div>
            </Block>
        );
    }

    return (
        <Block
            flexDirection='column'
            justifyContent='start'
            alignItems='start'
            width="75%"
            height='fit-content'
            background={backgroundColor}
            header='ДОКУМЕНТЫ'
            headerColor={textColor}
            id='documents'
            aria-label="Документы образовательной организации"
            role="region"
        >
            <FadeIn>
                <div className={style.content}>
                    <div className={style.wrapperData} role="list">
                        {documentsData.docs?.map((doc) => (
                            <section 
                                key={doc.id}
                                className={style.row}
                                aria-labelledby={`${doc.id}-title`}
                                role="listitem"
                            >
                                <div className={style.text} style={{ color: textColor }}>
                                    {doc.File?.data?.attributes?.url ? (
                                        <Link
                                            href={`${doc.File.data.attributes.url}`}
                                            children={doc.Name}
                                            color={linkColor}
                                            fontFamily='Roboto, sans-serif'
                                            fontSize='1rem'
                                            fontWeight='500'
                                            aria-label={`Скачать документ: ${doc.Name}`}
                                            download
                                        />
                                    ) : (
                                        <span style={{ fontStyle: 'italic', color: '#666' }}>
                                            {doc.Name} (файл не прикреплен)
                                        </span>
                                    )}
                                </div>
                            </section>
                        ))}
                    </div>
                    
                    {/* Отчет о самообследовании */}
                    <section className={style.row}>
                        <h3 style={{ color: textColor }}>
                            Отчет о результатах самообследования
                        </h3>
                        <p style={{ color: textColor }}>
                            Отчет о результатах самообследования за 2024 год отсутствует, так как образовательная деятельность в 2024 году не осуществлялась
                        </p>
                    </section>
                </div>
            </FadeIn>
        </Block>
    )
}

export default DocumentsBlock;